import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import NewsContent from "../components/NewsContent";

function News() {
  return (
    <>
      <Navigation />
      <NewsContent />
      <Footer />
    </>
  );
}

export default News;
